// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"Mobile_wrapper__17mUX"};